import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const SERVICES = [{
  number: '01',
  title: 'Brand & Positioning',
  body: 'Client interviews, competitive analysis, and messaging frameworks that make your offer the obvious choice in the education market.',
  tags: ['Positioning', 'Messaging', 'Brand systems']
}, {
  number: '02',
  title: 'Marketing Automation',
  body: 'End-to-end outreach systems — email, nurture, and follow-up — that run without adding headcount and keep your pipeline full.',
  tags: ['Email', 'Nurture', 'CRM setup']
}, {
  number: '03',
  title: 'Sales Conversion',
  body: 'High-converting sales letters, funnels, and offers that turn warm prospects into high-paying clients at double the rate.',
  tags: ['Funnels', 'Sales copy', 'Offers']
}, {
  number: '04',
  title: 'AI-Powered Growth',
  body: 'We harness AI to predict market shifts and adapt your campaigns — so your growth compounds instead of stalling.',
  tags: ['Forecasting', 'AI content', 'Optimization']
}];
export function Services() {
  return <section id="services" className="w-full bg-ink-950 py-24 text-white lg:py-32" data-id="element-127" data-mp="3b4r354n3ljsg">
      <div className="mx-auto max-w-container px-6 lg:px-8" data-id="element-128" data-mp="2xd2tr948h9f6">
        <Reveal className="max-w-2xl" data-id="element-129" data-mp="32ami51unb2ku">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-gold-400" data-id="element-130" data-mp="32bnxhiip2b8d">
            What we do
          </span>
          <h2 className="mt-4 font-display text-3xl font-semibold leading-tight tracking-tight lg:text-5xl" data-id="element-131" data-mp="3pyckgimk8tvu">
            Full-service growth for education businesses.
          </h2>
        </Reveal>

        <div className="mt-16 grid gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/10 sm:grid-cols-2" data-id="element-132" data-mp="3g4dlfshs9q84">
          {SERVICES.map((service, i) => <Reveal key={service.number} delay={i % 2 * 0.1} data-id="element-133" data-mp="24mci2sef6owd" data-mpi={i}>
              <div className="group flex h-full flex-col bg-ink-950 p-8 transition-colors hover:bg-ink-900 lg:p-10" data-id="element-134" data-mp="29mqe1c2qy8e1">
                <div className="flex items-start justify-between" data-id="element-135" data-mp="1pj17pztm1usm">
                  <span className="font-display text-2xl font-semibold text-gold-500" data-id="element-136" data-mp="1lir3arlgvcfv">
                    {service.number}
                  </span>
                  <ArrowUpRightIcon className="h-5 w-5 text-white/30 transition-all group-hover:text-gold-400" data-id="element-137" data-mp="1gq7q3vqoyjbl" />
                </div>
                <h3 className="mt-6 font-display text-2xl font-semibold" data-id="element-138" data-mp="1bqv2h8rzx87y">
                  {service.title}
                </h3>
                <p className="mt-3 flex-1 text-[15px] leading-relaxed text-white/60" data-id="element-139" data-mp="11u05wvfa9hwb">
                  {service.body}
                </p>
                <div className="mt-6 flex flex-wrap gap-2" data-id="element-140" data-mp="xtg8rrupmea6">
                  {service.tags.map(tag => <span key={tag} className="rounded-full border border-white/15 px-3 py-1 text-xs font-medium text-white/70" data-id="element-141" data-mp="svo6q50cpbs9">
                      {tag}
                    </span>)}
                </div>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}